// extracted by mini-css-extract-plugin
module.exports = {"root":"_36wyF","theme-based":"_1QaN1","themeBased":"_1QaN1","content":"_2VbxO"};